export default {
  // 标题
  title: "交易数量配置",

  // 复选框
  includeZero: "包含0",

  // 错误提示
  maxValueError: "最大值需大于最小值",

  // 按钮
  reset: "重置",
  confirm: "确定",

  // 成功消息
  saveSuccess: "保存成功",
};
